export default {
    cn: {
        bBookReport: {
            bGroup: 'B-Book 组别：',
            aAccount: 'A-Book 账号：',
            tip: 'A-Book 账号不能为空',
            downloadName: 'B-Book报表',
            sum: { TOTAL: '合计', part: 'part', index: 1 },
            tableHead: [
                { key: 'SYMBOL', value: '产品' },
                { key: 'B_DEALS', value: 'B-Bk 交易量' },
                { key: 'B_BUY_VOLUME', value: 'B-Bk 买手数' },
                { key: 'B_BUY_PRICE', value: 'B-Bk 买价' },
                { key: 'B_SELL_VOLUME', value: 'B-Bk 卖手数' },
                { key: 'B_SELL_PRICE', value: 'B-Bk 卖价' },
                { key: 'B_NET_VOLUME', value: 'B-Bk 手数差' },
                { key: 'B_PROFIT', value: 'B-Bk 利润(美元)' },
                { key: 'A_DEALS', value: 'A-Bk 交易量' },
                { key: 'A_BUY_VOLUME', value: 'A-Bk 买手数' },
                { key: 'A_BUY_PRICE', value: 'A-Bk 买价' },
                { key: 'A_SELL_VOLUME', value: 'A-Bk 卖手数' },
                { key: 'A_SELL_PRICE', value: 'A-Bk 卖价' },
                { key: 'A_NET_VOLUME', value: 'A-Bk 手数差' },
                { key: 'A_PROFIT', value: 'A-Bk 利润(美元)' },
                { key: 'NET_BUY_VOLUME', value: 'Net 买手数' },
                { key: 'NET_BUY_PRICE', value: 'Net 买价' },
                { key: 'NET_SELL_VOLUME', value: 'Net 卖手数' },
                { key: 'NET_SELL_PRICE', value: 'Net 卖价' },
                { key: 'NET_PROFIT', value: 'Net 利润(美元)' }
            ]
        }
    },
    hk: {
        bBookReport: {
            bGroup: 'B-Book 組別：',
            aAccount: 'A-Book 賬號：',
            tip: 'A-Book 賬號不能為空',
            downloadName: 'B-Book報表',
            sum: { TOTAL: '合計', part: 'part', index: 1 },
            tableHead: [
                { key: 'SYMBOL', value: '產品' },
                { key: 'B_DEALS', value: 'B-Bk 交易量' },
                { key: 'B_BUY_VOLUME', value: 'B-Bk 買手數' },
                { key: 'B_BUY_PRICE', value: 'B-Bk 買價' },
                { key: 'B_SELL_VOLUME', value: 'B-Bk 賣手數' },
                { key: 'B_SELL_PRICE', value: 'B-Bk 賣價' },
                { key: 'B_NET_VOLUME', value: 'B-Bk 手數差' },
                { key: 'B_PROFIT', value: 'B-Bk 利潤(美元)' },
                { key: 'A_DEALS', value: 'A-Bk 交易量' },
                { key: 'A_BUY_VOLUME', value: 'A-Bk 買手數' },
                { key: 'A_BUY_PRICE', value: 'A-Bk 買價' },
                { key: 'A_SELL_VOLUME', value: 'A-Bk 賣手數' },
                { key: 'A_SELL_PRICE', value: 'A-Bk 賣價' },
                { key: 'A_NET_VOLUME', value: 'A-Bk 手数差' },
                { key: 'A_PROFIT', value: 'A-Bk 利潤(美元)' },
                { key: 'NET_BUY_VOLUME', value: 'Net 買手數' },
                { key: 'NET_BUY_PRICE', value: 'Net 買價' },
                { key: 'NET_SELL_VOLUME', value: 'Net 賣手數' },
                { key: 'NET_SELL_PRICE', value: 'Net 賣價' },
                { key: 'NET_PROFIT', value: 'Net 利潤(美元)' }
            ]
        }
    },
    en: {
        bBookReport: {
            bGroup: 'B-Book Group：',
            aAccount: 'A-Book Account：',
            tip: 'A-Book Account Can\'t be empty',
            downloadName: 'B-Book-Report',
            sum: { TOTAL: 'Summary', part: 'part', index: 1 },
            tableHead: [
                { key: 'SYMBOL', value: 'Products' },
                { key: 'B_DEALS', value: 'B-Bk Deals' },
                { key: 'B_BUY_VOLUME', value: 'B-Bk Buy Volume' },
                { key: 'B_BUY_PRICE', value: 'B-Bk Buy Price' },
                { key: 'B_SELL_VOLUME', value: 'B-Bk Sell Volume' },
                { key: 'B_SELL_PRICE', value: 'B-Bk Sell Price' },
                { key: 'B_NET_VOLUME', value: 'B-Bk Net Volume' },
                { key: 'B_PROFIT', value: 'B-Bk Profit (USD)' },
                { key: 'A_DEALS', value: 'A-Bk Deals' },
                { key: 'A_BUY_VOLUME', value: 'A-Bk Buy Volume' },
                { key: 'A_BUY_PRICE', value: 'A-Bk Buy Price' },
                { key: 'A_SELL_VOLUME', value: 'A-Bk Sell Volume' },
                { key: 'A_SELL_PRICE', value: 'A-Bk Sell Price' },
                { key: 'A_NET_VOLUME', value: 'A-Bk Net Volume' },
                { key: 'A_PROFIT', value: 'A-Bk Profit (USD)' },
                { key: 'NET_BUY_VOLUME', value: 'Net Buy Volume' },
                { key: 'NET_BUY_PRICE', value: 'Net Buy Price' },
                { key: 'NET_SELL_VOLUME', value: 'Net Sell Volume' },
                { key: 'NET_SELL_PRICE', value: 'Net Sell Price' },
                { key: 'NET_PROFIT', value: 'Net Profit (USD)' }
            ]
        }
    },
}


// WEBPACK FOOTER //
// ./src/language/report/bBookReport.js